












































import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { Expert } from "@/types";

@Component
export default class DisplayExperts extends Vue {
  @Prop() experts!: Expert[];

  @Prop() loading!: boolean;

  isLoading: boolean = false;

  options = JSON.parse(localStorage.getItem("list_expert_option") ?? "{}");
  search = localStorage.getItem("list_expert_search") ?? "";

  selected: any = [];

  /*pagination: any = {
    sortBy: "createdAt",
  };*/

  headers: any = [
    { text: "Spécialité", value: "field", sortable: false },
    { text: "Nom", value: "name", sortable: false },
    { text: "Prenom", value: "firstname", align: " d-none" },
    { text: "Nom", value: "lastname", align: " d-none" },
    { text: "Email", value: "email" },
    { text: "Date de création", value: "createdAt" },
    { text: "Actions", value: "action", sortable: false },
  ];

  @Watch("loading", { immediate: true })
  handleLoadingChange(value: boolean) {
    this.isLoading = value;
    if (!this.loading) {
      this.search = JSON.parse(
        localStorage.getItem("list_expert_search") ?? ""
      );
      this.options = JSON.parse(
        localStorage.getItem("list_expert_option") ?? "{}"
      );
    }
  }

  @Watch("options", { immediate: true })
  handleOptionsChange(value: any) {
    if (!this.loading) {
      const myOption = {
        itemsPerPage: value.itemsPerPage,
        page: value.page,
        sortBy: value.sortBy,
        sortDesc: value.sortDesc,
      };
      localStorage.setItem("list_expert_option", JSON.stringify(myOption));
    }
  }

  @Watch("search", { immediate: true })
  handleSearchChange(value: string) {
    if (!this.loading) {
      localStorage.setItem("list_expert_search", value);
    }
  }

  toggleAll() {
    if (this.selected.length) this.selected = [];
    else this.selected = this.experts.slice();
  }

  /*changeSort(column: string) {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }*/
}
